import './styles/youtube-modal.css';

import { YouTubeModalController } from '$utils/youtube-modal';

window.Webflow ||= [];
window.Webflow.push(() => {
  // Initialize YouTube modal
  const youtubeModalController = new YouTubeModalController();
  youtubeModalController.init();
});
